import { Col, Input, Pagination, Row } from "antd";
import { HiOutlineSearch } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import useMedia from "use-media";
import { useSearchParams } from "react-router-dom";
import {
  Box,
  Button,
  Loader,
  Modal,
  ProfileImage,
  Switch,
  Table,
  Text,
  TextField,
} from "../../components";
import { ApiCaller, Colors, Fonts, Images, Utils } from "../../config";
import { ServiceProvidersAction } from "../../store/actions";
import "./index.css";

const { TextArea } = Input;

const exportingServiceProviders = async (state, callback) => {
  const { limit, offset, search, status } = state
  try {
    let res = await ApiCaller.Get(`/admin/export/service-provider?limit=${limit}&offset=${offset}&status=${!!status ? status : 'all'}&search=${search}`);
    if (res?.status == 200) {
      Utils.showSnackBar({ message: res?.data?.data?.message });
      callback && callback(res?.data?.data?.url)
    } else {
      Utils.showSnackBar({
        message: res?.data?.error?.message,
        severity: "error",
      });
    }
  } catch (error) {
    Utils.showSnackBar({
      message: error?.data?.error?.message,
      severity: "error",
    });
  }
}

// submit a commission 
export const submitCommission = async (data) => {
  try {
    const { id, ...rest } = data;
    let res = await ApiCaller.Put(`/admin/service-provider/${id}`, { ...rest });
    if (res?.status == 200 || res?.data?.status == 200) {
      return res?.data?.data
    }
    else {
      Utils.showSnackBar({ message: res?.data?.error?.message, severity: "error" });
    }
  } catch (error) {
    Utils.showSnackBar({ message: error?.data?.error?.message, severity: "error" });
  }
}

function ProviderManagement() {
  const isTablet = useMedia({ minWidth: "768px" });
  const isMobile = useMedia({ minWidth: "550px" });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");
  const [subjectError, setSubjectError] = useState("");
  const [messageError, setMessageError] = useState("");
  const [page, setPage] = useState(1);
  const [selectedUser, setSelectedUser] = useState(null);
  const [dashboardPendingDocsState, setDashboardPendingDocsState] = useState(false);
  const serviceProviders = useSelector((state) => state.serviceProviders);
  const [state, setState] = useState({
    limit: 10,
    offset: 0,
    search: "",
    status: "",
    filter: ""
  });

  // commission modal
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [messageDetails, setMessageDetails] = useState({
    id: null,
    isEnabled: false,
    percentage: 0
  })


  const [exportModal, setExportModal] = useState(false);

  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");

  useEffect(() => {
    if (status) {
      setState({ ...state, status: status })
    }
  }, [])

  // export date handler
  const exportDataHandler = () => {
    exportingServiceProviders(state, (res) => {
      window.open(res, "_blank");
      setExportModal(false)
    })
  }


  useEffect(() => {
    if (state && location.state?.dashboardState && !status) {
      // console.log('dashboard state in Sp', location.state?.dashboardState); 
      setState({
        ...state,
        limit: 10,
        offset: 0,
        search: "",
        status: "",
        filter: location.state?.dashboardState || 'testing',
      })
      setDashboardPendingDocsState(true);
      // alert('')
      // dispatch(ServiceProvidersAction.getAllServiceProviders({...state,filter:location.state?.dashboardState}));
    }

  }, []);
  // }, [location.state?.dashboardState]);
  // console.log("state after me" ,state)


  const handleStatusFilter = (checked, id) => {
    setState({
      ...state,
      status: checked,
    });
  };

  const handleSearchUsers = (e) => {
    setState({
      ...state,
      search: e.target.value.trimStart(),
      offset: 0
    });
    // handlePaginationChange(1)
    setPage(1)

  };

  const handleChangeStatus = (id, status) => {
    // console.log("handle change clicked")
    const payload = {
      status: status,
    };
    dispatch(
      ServiceProvidersAction.updateServiceProviderStatus(id, payload, () => {
        dispatch(ServiceProvidersAction.getAllServiceProviders(state));
      })
    );
  };

  const handleSendEmail = () => {
    if (subject.length === 0 || subject.trim() === "") {
      setSubjectError("Please enter subject");
    } else if (message.length === 0 || message.trim() === "") {
      setSubjectError("");
      setMessageError("Please enter message");
    } else {
      setSubjectError("");
      setMessageError("");
      const payload = {
        subject: subject?.trim(),
        message: message?.replace(/\n|\r/g, "<br/><br/>"),
      };
      dispatch(
        ServiceProvidersAction.sendServiceProviderEmail(
          selectedUser.id,
          payload,
          () => {
            setShowModal(false);
            setSubject("");
            setMessage("");
          }
        )
      );
    }
  };

  const handleNavigateUserDetails = (record) => {
    // navigate("/provider-management/details", {
    //   // state: {
    //   //   id: record.id,
    //   // },
    //   state: { state, id: record.id, page }
    // });
    console.log(record)
    navigate(`/service-provider/${record?.id}`)
  };

  const handlePaginationChange = (pageNumber) => {
    let offset = (pageNumber - 1) * state.limit;
    // alert('my location',location.state?.dashboardState);
    // console.log('my location',location.state?.dashboardState);

    setState({ ...state, offset: offset });
    setPage(pageNumber);
  };

  useEffect(() => {
    if (location.state?.locationpage && !dashboardPendingDocsState) {
      // const {limit,offset} = location?.state?.locationstate;
      const pagenumber = location?.state?.locationpage;
      // setState({...state,limit:limit,offset:offset})
      // dispatch(ServiceProvidersAction.getAllServiceProviders({...state,limit:limit,offset:offset}))
      handlePaginationChange(pagenumber)
      navigate(location.pathname, {})
      // alert('hello ')
    }

    else {
      console.log('calling SP state', state);
      dispatch(ServiceProvidersAction.getAllServiceProviders(state));
    }

  }, [state]);



  // commission toggle change handler
  // case 1: if toggle value is true then a modal going to open - user enter commission - submit
  // case 2: else if value is false then just make the percentage 0 for that service.
  const handlePercentageChangeStatus = async (id, value) => {
    let payload = {
      id,
      isEnabled: value,
      percentage: 0
    }
    setMessageDetails(payload)
    // if true then we have to show a modal to enter commission.
    if (value) {
      setShowCommissionModal(value)
    }
    // or else we just have to make a commission percentage 0 for that service.
    else {
      let res = await submitCommission(payload);
      if (res) {
        setMessageDetails({
          id: null,
          isEnabled: false,
          percentage: 0
        })
        Utils.showSnackBar({ message: res?.message });
        dispatch(ServiceProvidersAction.getAllServiceProviders(state));
      }
    }
  }

  // commission submit handler
  const commissionSubmitHandler = async () => {
    if (messageDetails?.percentage == 0) return
    else if (messageDetails?.percentage > 100) {
      Utils.showSnackBar({ message: "Percentage should not be greater than 100", severity: "error" });
      return
    }
    let res = await submitCommission(messageDetails);
    if (res) {
      setShowCommissionModal(false)
      setMessageDetails({
        id: null,
        isEnabled: false,
        percentage: 0
      })
      Utils.showSnackBar({ message: res?.message });
      dispatch(ServiceProvidersAction.getAllServiceProviders(state));
    }
  }



  return (
    <>
      <Box>
        <Row justify="space-between" gutter={[16, 32]}>
          <Col className="flex-start">
            <Text.Heading
              fontSize={24}
              fontFamily={Fonts["Poppins-SemiBold"]}
              color={Colors.Black}
              fontWeight={600}
              text={"Service Provider Management"}
              textAlign={'left'}
            />
          </Col>
          <Col
            md={14}
            sm={isTablet ? 19 : 24}
            className={isTablet ? "flex-end" : "flex-row-start mt-20"}
          >
            <Row className={isMobile ? "flex-center" : "flex-column"}>
              <Col
                span={isMobile ? undefined : 14}
                className="export-btn-col"
              >
                <Button.Basic
                  onClick={() => {
                    setExportModal(true);
                  }}
                  text={"Export Data"}
                  className="add-admin-btn export-btn"
                />
              </Col>
              <Col span={isMobile ? 7 : 9}>
                <TextField.SelectField
                  placeholder="Select"
                  size="large"
                  id="provider-management-select"
                  type="text"
                  disabled={false}
                  required={false}
                  value={state.status ? state.status : "All Status"}
                  label=""
                  defaultValue="All Status"
                  error={false}
                  helperText=""
                  onChange={handleStatusFilter}
                  data={[
                    {
                      label: "All Status",
                      value: "",
                    },
                    {
                      label: "Active",
                      value: "1",
                    },
                    {
                      label: "Banned",
                      value: "2",
                    },
                    {
                      label: "Pending",
                      value: "3",
                    },
                  ]}
                />
              </Col>
              <Col span={isMobile ? 10 : 20} className={!isMobile && "mt-5"}>
                <TextField.CustomInput
                  placeholder="Search"
                  size="large"
                  id="provider-management-search"
                  className="user-search-field"
                  type="text"
                  disabled={false}
                  required={false}
                  value={state.search}
                  label=""
                  defaultValue=""
                  error={false}
                  helperText=""
                  onChange={handleSearchUsers}
                  prefix={<HiOutlineSearch color={Colors.dropdownTextColor} />}
                  bgColor={Colors.dropdownBgColor}
                  color={Colors.dropdownTextColor}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row justify="space-between" className="mt-20" style={{ fontSize: '13px' }}>
          <Col span={24}>
            {serviceProviders.isLoading ? (
              <Col
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTp: "20px",
                }}
              >
                <Loader.Circular />
              </Col>
            ) : (
              <>
                <Table.AntDesignTable
                  className="user-table"
                  // onRow={(record, index) => ({
                  //   onClick: () => {
                  //     handleNavigateUserDetails(record, index);
                  //   },
                  // })}
                  columns={[
                    {
                      title: "Id",
                      dataIndex: "userDetail",
                      key: "userDetail",
                      render: (text, record) => {
                        return (
                          <span>{text.counter ? text.counter : '-'}</span>
                        )
                      },
                    },
                    {
                      title: "Image",
                      dataIndex: "imageThumbUrl",
                      key: "imageThumbUrl",
                      render: (text, record) => (
                        <ProfileImage
                          className="service-user-img"
                          src={record.imageThumbUrl}
                          width={40}
                          alt="user"
                          onClick={() => handleNavigateUserDetails(record)}
                        />
                      ),
                    },
                    {
                      title: "Full Name",
                      dataIndex: "fullName",
                      key: "fullName",
                      render: (text, record) => {
                        return (
                          <span
                            onClick={() => handleNavigateUserDetails(record)}
                          >
                            {text.length > 20
                              ? `${text.slice(0, 20)}...`
                              : text}
                          </span>
                        );
                      },
                    },
                    {
                      title: "Email",
                      dataIndex: "email",
                      key: "email",
                      render: (text, record) => {
                        return (
                          <span
                            className="service-email"
                            onClick={() => handleNavigateUserDetails(record)}
                          >
                            {text}
                          </span>
                        );
                      },
                    },
                    {
                      title: "Phone Number",
                      dataIndex: "phoneNo",
                      key: "phoneNo",
                      render: (text, record) => {
                        return (
                          <span
                          >
                            {text}
                          </span>
                        );
                      },
                    },
                    {
                      title: "Subscription",
                      dataIndex: "subscription",
                      key: "subscription",
                      render: (text, record) => {
                        return (
                          <span
                          >
                            {record.userDetail.isSubscribed
                              ? "Subscribed"
                              : "UnSubscribed"}
                          </span>
                        );
                      },
                    },
                    // two more columns added for commission percentage assigning.
                    {
                      title: "Percentage",
                      dataIndex: "percentage",
                      key: "percentage",
                      render: (text, record) => (
                        <span>
                          {record?.userDetail?.percentage?.toFixed(2)} %
                          {/* 0 % */}
                        </span>
                      ),
                    },
                    {
                      title: "Commission Action",
                      dataIndex: "",
                      render: (text, record) =>
                        record?.status !== 3 && (
                          <Switch.Basic
                            checked={record?.userDetail?.isEnabled}
                            // checked={false}
                            onChange={(value) =>
                              handlePercentageChangeStatus(
                                record?.id,
                                value
                              )
                            }
                          />
                        ),
                    },
                    {
                      title: "Document Status",
                      dataIndex: "userDetail",
                      key: "userDetail",
                      render: (text, record) => {
                        console.log("complete record for service provider === ", text)
                        return (
                          <div
                            // className="user-status"
                            style={{
                              color: '#fff',
                              fontFamily: "Poppins",
                              fontWeight: '500',
                              borderRadius: '10px',
                              height: '40px',
                              display: 'flex',
                              fontSize: "12px",
                              // width: "80px",
                              justifyContent: 'center',
                              alignItems: 'center',
                              backgroundColor:
                                text.status === 1
                                  ? Colors.Green
                                  : text.status === 2
                                    ? Colors.Pink
                                    : text.status === 3
                                      ? Colors.Danger
                                      : Colors.Primary,
                            }}
                          >
                            {
                              // UPLOADED: 0, 
                              // APPROVED: 1,
                              // REJECTED: 2,
                              // NOT_SUBMITTED: 3,
                              text.status === 0 ? 'Pending' : text.status === 1 ? 'Approved' : text.status === 2 ? 'Rejected' : text.status === 3 ? 'Not Submitted' : 'Pending'
                            }
                          </div>

                        );
                      },
                    },
                    {
                      title: "",
                      dataIndex: "",
                      render: (text, record) => (
                        <img
                          onClick={() => {
                            setSelectedUser(record);
                            setShowModal(true);
                          }}
                          src={Images.Emailcon}
                          alt=""
                        />
                      ),
                    },
                    {
                      title: "Status",
                      dataIndex: "status",
                      key: "status",
                      render: (text, record) => (
                        <div
                          // className="user-status"
                          style={{
                            color: '#fff',
                            fontFamily: "Poppins",
                            fontWeight: '500',
                            borderRadius: '10px',
                            height: '40px',
                            display: 'flex',
                            fontSize: "12px",
                            width: "80px",
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor:
                              record.status === 1
                                ? Colors.Green
                                : record.status === 2
                                  ? Colors.Pink
                                  : Colors.Primary,

                          }}
                        >
                          {record.status === 1
                            ? "Active"
                            : record.status === 2
                              ? "Banned"
                              : "Pending"}
                        </div>
                      ),
                    },
                    {
                      title: "",
                      dataIndex: "",
                      render: (text, record) =>
                        record.status !== 3 && (
                          <Switch.Basic
                            checked={record.status === 1 ? true : false}
                            onChange={() =>
                              handleChangeStatus(
                                record.id,
                                record.status === 1 ? 2 : 1
                              )
                            }
                          />
                        ),
                    },
                  ]}
                  data={serviceProviders.serviceProviders}
                  pagination={true}
                  rowKey="key"
                  loading={false}
                />
                <Row justify="center" className="mt-20">
                  <Col>
                    <Pagination
                      responsive="true"
                      showLessItems="true"
                      current={page}
                      pageSize={10}
                      total={serviceProviders.count}
                      onChange={handlePaginationChange}
                    />
                  </Col>
                </Row>
              </>
            )}
          </Col>
        </Row>
      </Box >
      {showModal && (
        <Modal.AntDesignModal
          title=""
          isModalVisible={showModal}
          handleCancel={() => {
            setShowModal(false);
            setSubjectError("");
            setMessageError("");
            setSubject("");
            setMessage("");
          }}
        >
          <Row justify="center">
            <Col>
              <Text.Heading
                fontSize={24}
                fontFamily={Fonts["Poppins-SemiBold"]}
                color={Colors.Black}
                fontWeight={600}
                text={"Send Message"}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24} className="flex-row mt-20">
              <Col>
                <ProfileImage
                  src={selectedUser?.imageThumbUrl}
                  alt="provider"
                  className="service-user-email-img"
                />
              </Col>
              <Col>
                <div className="flex-column ml-20">
                  <Text.Heading
                    fontSize={18}
                    fontFamily={Fonts["Poppins-Bold"]}
                    color={Colors.Black}
                    fontWeight={600}
                    text={
                      selectedUser.fullName.length > 40
                        ? `${selectedUser.fullName.slice(0, 40)}...`
                        : selectedUser.fullName
                    }
                    textAlign="left"
                  />
                  <Text.Heading
                    fontSize={16}
                    fontFamily={Fonts["Poppins-Medium"]}
                    color={Colors.Black}
                    fontWeight={500}
                    text={selectedUser.email}
                    textAlign="left"
                  />
                </div>
              </Col>
            </Col>
          </Row>
          <Row className="mt-20">
            <Col span={24}>
              <TextField.CustomInput
                label="Subject:"
                color={Colors.Black}
                placeholder="Email Subject"
                value={subject}
                size="large"
                type="text"
                className="user-subject-field"
                onChange={(e) => setSubject(e.target.value)}
              />
            </Col>
            {subjectError && (
              <Col>
                <Text.ErrorText
                  fontSize={14}
                  fontFamily={Fonts["Poppins-Medium"]}
                  color={Colors.Red}
                  fontWeight={500}
                  text={subjectError}
                  textAlign="left"
                />
              </Col>
            )}
          </Row>
          <Row className="my-20">
            <Col span={24}>
              <label className="service-provider-msg-label">Message:</label>
              <TextArea
                placeholder="Write your message here"
                value={message}
                rows={5}
                size="large"
                type="text"
                className="service-provider-msg-input"
                onChange={(e) => {
                  setMessage(e.target.value);
                }}
              />
            </Col>
            {messageError && (
              <Col>
                <Text.ErrorText
                  fontSize={14}
                  fontFamily={Fonts["Poppins-Medium"]}
                  color={Colors.Red}
                  fontWeight={500}
                  text={messageError}
                  textAlign="left"
                />
              </Col>
            )}
          </Row>
          <Row justify="center">
            <Col span={24}>
              <Button.Basic
                onClick={handleSendEmail}
                text={"Send"}
                className="service-provider-email-btn"
              />
            </Col>
          </Row>
        </Modal.AntDesignModal>
      )
      }

      {
        exportModal &&
        <Modal.ConfirmationModal
          title={""}
          isModalVisible={exportModal}
          heading={"Are you sure you want to export?"}
          handleCancel={() => setExportModal(false)}
          handleDelete={() => exportDataHandler()}
        >
        </Modal.ConfirmationModal>
      }

      {/* commission amount modal */}
      {
        showCommissionModal && (
          <Modal.AntDesignModal
            className=""
            centered={true}
            title=""
            isModalVisible={showCommissionModal}
            handleCancel={() => {
              setShowCommissionModal(false);
              setMessageDetails({
                id: null,
                isEnabled: false,
                percentage: 0
              });
            }}
          >
            <Row className="" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              <Col>
                <Text.Heading
                  fontSize={24}
                  fontFamily={Fonts["Poppins-SemiBold"]}
                  color={Colors.Black}
                  fontWeight={600}
                  text={"Set Commission"}
                />
              </Col>

              <Col span={24} style={{ marginTop: '10px' }}>
                <TextField.CustomInput
                  value={messageDetails?.percentage}
                  placeholder={"Commission ..."}
                  style={{ border: '1px solid', width: '150px', padding: '6px', borderRadius: '6px' }}
                  onChange={(e) => setMessageDetails({ ...messageDetails, percentage: Number(e.target.value) })}
                />
              </Col>
              <Row className="mt-20 flex-end">
                <Col>
                  <Button.Basic
                    onClick={commissionSubmitHandler}
                    text={"Send"}
                    className="message-btn w-500 mr-10"
                  />
                </Col>
              </Row>
            </Row>
          </Modal.AntDesignModal>
        )
      }
    </>
  );
}

export default ProviderManagement;
